import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ElementsHandler from './ElementsHandler';
import { idleTimer } from '../../helper/jQuery-idleTimer';

class GlobalElementsWrapper extends Component {
  static childContextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    submissionOn: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);

    this.elementsRef = React.createRef();
  }

  getChildContext() {
    return {
      showLoading: this.showLoading,
      hideLoading: this.hideLoading,
      submissionOn: this.submissionOn
    };
  }

  componentDidMount() {
    const elementsHandler = this.elementsRef.current;
    idleTimer(elementsHandler && elementsHandler.showIdleDialog, 1000 * 60 * 30);
  }

  showLoading = () => {
    const elementsHandler = this.elementsRef.current;
    elementsHandler && elementsHandler.showLoading();
  };

  hideLoading = () => {
    const elementsHandler = this.elementsRef.current;
    elementsHandler && elementsHandler.hideLoading();
  };

  submissionOn = flag => {
    const elementsHandler = this.elementsRef.current;
    elementsHandler && elementsHandler.submissionOn(flag);
  };

  handleChildren = children => {
    return React.Children.map(children, child =>
      React.cloneElement(child, {
        showLoading: this.showLoading,
        hideLoading: this.hideLoading
      })
    );
  };

  render() {
    return (
      <div>
        <ElementsHandler ref={this.elementsRef} />
        {this.handleChildren(this.props.children)}
      </div>
    );
  }
}

export default GlobalElementsWrapper;
